export default function CFIsTestimonials() {
  const testimonials = [
    {
      quote: "WingmanFix has completely transformed how I track student progress. Instead of scattered notes and memory, I have detailed analytics on every flight. My students are soloing faster and with more confidence.",
      name: "Sarah Mitchell",
      role: "CFI-I, MEI",
      school: "Skybound Flight Academy",
      rating: "Gold Seal Instructor",
      hours: "3,200+ hours instructing"
    },
    {
      quote: "The debrief tools are incredible. Being able to replay the flight with my student and point to exact moments where they can improve has made my instruction so much more effective. Parents love the detailed progress reports too.",
      name: "Marcus Chen",
      role: "CFI, CFII",
      school: "Pacific Coast Aviation",
      rating: "Master CFI",
      hours: "2,800+ hours instructing"
    },
    {
      quote: "As a chief instructor managing 8 CFIs and 40+ students, WingmanFix gives me visibility I never had before. I can see which students need extra attention and which instructors need support. It's like having a co-pilot for the entire operation.",
      name: "Jennifer Rodriguez",
      role: "Chief Flight Instructor",
      school: "Horizon Flight Training Center",
      rating: "Gold Seal, Master CFI",
      hours: "5,100+ hours instructing"
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#0A1628] to-[#0D1B33]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-6">
            <i className="ri-star-fill text-emerald-400 text-lg"></i>
            <span className="text-emerald-400 font-medium text-sm">Trusted by Flight Instructors</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            What CFIs Are Saying
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Join hundreds of instructors who are elevating their teaching with data-driven insights
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#1a2942] to-[#0f1d30] rounded-2xl p-8 border border-gray-700/50 hover:border-emerald-500/30 transition-all duration-300 hover:shadow-xl hover:shadow-emerald-500/10 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-300 text-base leading-relaxed mb-8 flex-grow">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-gray-700/50 pt-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-bold text-white text-lg mb-1">
                      {testimonial.name}
                    </h4>
                    <p className="text-emerald-400 text-sm font-medium mb-1">
                      {testimonial.role}
                    </p>
                    <p className="text-gray-400 text-sm mb-2">
                      {testimonial.school}
                    </p>
                    <div className="flex flex-col gap-1">
                      <span className="text-xs text-gray-500 flex items-center gap-1">
                        <i className="ri-award-fill text-yellow-400"></i>
                        {testimonial.rating}
                      </span>
                      <span className="text-xs text-gray-500 flex items-center gap-1">
                        <i className="ri-time-fill text-blue-400"></i>
                        {testimonial.hours}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-400 text-sm">
            <i className="ri-shield-check-fill text-emerald-400 mr-2"></i>
            Verified reviews from active flight instructors
          </p>
        </div>
      </div>
    </section>
  );
}